<template>
  <div>
    <div class="content">
      <div class="service_content">
        <p class="title">关于<common-data name="appShortName_37"/></p>
        <p style="margin-top: 15px" class="text_content">
          文华财经旗下星格研究所的旗舰产品之一，面向专业投资机构。
        </p>
        <p class="title2">股票投资平台</p>
        <p class="text_content">
          支持市场中性等股票量化策略，以及可转债策略的研发，提供了包括编写因子、可视化策略构建平台、回测报告、收益归因分析等功能，是一个集成化、全流程的股票量化投资工具。
        </p>
        <p class="text_content">
         软件提供的系统因子库，包含股票因子、可转债因子两大类，共计133个因子。其中，股票因子包含了量价类-技术指标、量价类-波动率因子、财务类-盈利能力等12个类别共计80多个因子；可转债因子包含了市场估值类、量价类、正股财报类、正股量价类4个类别共计40多个因子。该因子库既覆盖了大多数的常见因子，又集成了各大机构研究中的因子研究成果，并会不断上新。
        </p>
        <!-- <p class="text_content">
          内嵌的Python3编写语言，提供了丰富的系统函数和详尽的函数说明，支持获取涵盖系统因子、沪深股票及期货行情、沪深股票财务、宏观经济指标等多样化完整的结构化数据，支持自定义因子的编写和复杂策略的研究，快速实现各种量化策略。
        </p> -->

        <!-- <a
          href="https://www.wenhua.com.cn/popwin/wh10ldjx.html"
          target="_blank"
          class="turnto"
          >wh11量化功能亮点解析</a
        > -->
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.content {
  background: url(https://wh-api.wenhua.com.cn/api/WhBanner/GetWhBannerUrl?id=59) no-repeat top;
  width: 100%;
  min-height: 544px;
  padding-top: 236px;
}
.service_content {
  width: 990px;
  margin: 0 auto;
  background: #fff;
  border-radius: 10px;
  padding: 30px;
  box-shadow: 0 0 20px -5px #ccc;
  min-height: 462px;
  padding-bottom: 50px;
}
.service_content .title {
  color: #5f5f5f;
  border-bottom: 1px dashed #a8a8a8;
  line-height: 40px;
  font-size: 22px;
}
.text_content {
  text-indent: 2em;
  font-size: 14px;
  line-height: 20px;
  color: #6f6f6f;
  padding: 10px 0;
  text-align: justify;
}
.title2 {
  font-size: 16px;
  color: #5d0f0b;
  border-left: 4px solid #e24a49;
  font-weight: bold;
  padding-left: 10px;
  margin: 15px 0;
}
</style>